import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormComponentProps } from 'types/components';
import {
  FormattedInput,
  FormattedInputProps,
} from 'up-ops-web-shared-components/lib/components/inputs/formatted-input';

type FormFormattedInputProps = FormComponentProps & FormattedInputProps;

const FormFormattedInput = ({
  defaultValue = '',
  name,
  rules,
  ...props
}: FormFormattedInputProps) => {
  const { control, formState } = useFormContext();
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, ref, value } = field;
        const { error, invalid } = fieldState;
        return (
          <FormattedInput
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            innerRef={ref}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            {...props}
          />
        );
      }}
      rules={rules}
    />
  );
};

export default FormFormattedInput;
